import { cloneDeep } from "lodash";
import { ViewType } from "./SchedulingLayout";
import { getStartEndDateOfSameDay } from "../../../../utils/date-time-utility";
import dayjs from "dayjs";

export const getCalcFilterDate = (
  filterDate: [string, string],
  v?: ViewType,
  sDate?: Date,
  view?: ViewType
): [string, string] => {
  let startDate = sDate ?? new Date(filterDate[0]);

  let endDate = cloneDeep(startDate);
  const viewContent = v;

  switch (viewContent) {
    case "day": {
      const { endTime, startTime } = getStartEndDateOfSameDay(
        dayjs(view !== "day" ? new Date() : startDate)
      );
      endDate = endTime ? new Date(endTime) : endDate;
      startDate = startTime ? new Date(startTime) : startDate;
      break;
    }
    case "week": {
      const { sDate, eDate } = getWeekStartAndEnd(
        view !== "week" ? new Date() : startDate
      );
      startDate = sDate;
      endDate = eDate;
      break;
    }
    case "month": {
      endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
      endDate.setHours(23, 59, 0, 0);

      startDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
      break;
    }
  }

  return [startDate?.toISOString(), endDate?.toISOString()];
};

const SHARED_CALENDAR_STYLES = {
  "& .rbc-day-slot .rbc-time-slot": {
    borderTop: "none",
    background: "transparent !important",
    backgroundColor: "transparent !important",
    color: "#6B7280",
    fontSize: "12px",
  },
  "& .rbc-time-slot": {
    background: "transparent !important",
    backgroundColor: "transparent !important",
  },
  "& .rbc-time-gutter .rbc-timeslot-group": {
    borderBottom: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "& .rbc-label": {
    color: "#6B7280",
    fontSize: "12px",
    fontWeight: 400,
    padding: "0 8px",
    textAlign: "center",
  },
  "& .rbc-event": {
    border: "none !important",
    outline: "none",
    boxShadow: "none",
    padding: "0 !important",
    backgroundColor: "transparent !important",
  },
  "& .rbc-event:focus": {
    outline: "none",
  },
  "& .rbc-event-content": {
    height: "100%",
    overflow: "hidden",
    "& > div": {
      height: "100%",
    },
  },
  "& .rbc-current-time-indicator": {
    backgroundColor: "#104E84",
    height: "2px",
    "&::before": {
      content: '""',
      position: "absolute",
      left: "-5px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "14px",
      height: "14px",
      borderRadius: "50%",
      backgroundColor: "#104E84",
    },
  },
  "& .rbc-day-slot .rbc-events-container": {
    marginLeft: "0",
  },
  "& .rbc-today": {
    backgroundColor: "transparent !important",
  },
};

export const WEEK_VIEW_STYLES = {
  "& .rbc-time-view": {
    border: "1px solid #E5E7EB",
    marginTop: "8px",
  },
  "& .rbc-time-header": {
    marginRight: "0 !important",
  },
  "& .rbc-time-header-content": {
    borderLeft: "1px solid #E5E7EB",
  },
  "& .rbc-time-header-gutter": {
    width: "78px !important",
    minWidth: "78px !important",
    maxWidth: "78px !important",
  },
  "& .rbc-time-gutter": {
    width: "78px !important",
    minWidth: "78px !important",
    maxWidth: "78px !important",
    borderLeft: "1px solid #E5E7EB",
    borderRight: "1px solid #E5E7EB",
  },
  "& .rbc-time-content": {
    borderTop: "none",
  },
  "& .rbc-time-content > :first-of-type + *": {
    borderLeft: "1px solid #E5E7EB",
  },
  "& .rbc-day-bg + .rbc-day-bg": {
    borderLeft: "1px solid #E5E7EB",
  },
  "& .rbc-header + .rbc-header": {
    borderLeft: "1px solid #E5E7EB",
  },
  "& .rbc-timeslot-group": {
    borderBottom: "1px solid #E5E7EB",
    minHeight: "200px",
  },
  "& .rbc-events-container": {
    marginRight: "4px",
  },
  ...SHARED_CALENDAR_STYLES,
};

export const DAY_VIEW_STYLES = {
  "& .rbc-time-view": {
    border: "none",
  },
  "& .rbc-time-gutter": {
    borderLeft: "1px solid #E5E7EB",
    borderRight: "1px solid #E5E7EB",
  },
  "& .rbc-time-content": {
    borderTop: "none",
  },
  "& .rbc-time-content > * + * > *": {
    borderLeft: "none",
  },
  "& .rbc-timeslot-group": {
    borderBottom: "1px solid #E5E7EB",
    minHeight: "160px",
  },
  "& .rbc-time-header": {
    display: "none",
  },
  "& .rbc-allday-cell": {
    display: "none",
  },
  "& .rbc-events-container": {
    marginRight: "8px",
  },
  "& .rbc-day-bg": {
    border: "none",
  },
  ...SHARED_CALENDAR_STYLES,
};


export function getWeekStartAndEnd(selectedDate: Date) {
  const sDate = new Date(selectedDate);
  const eDate = new Date(selectedDate);

  const dayOfWeek = selectedDate.getDay();

  sDate.setDate(selectedDate.getDate() - dayOfWeek);
  sDate.setHours(0, 0, 0, 0);

  eDate.setDate(selectedDate.getDate() + (6 - dayOfWeek));
  eDate.setHours(23, 59, 0, 0);

  return { sDate, eDate };
}
